import React, { useRef } from 'react';
import { Button, ButtonProps } from '@indigo-ag/component-module';
import { v4 as uuidv4 } from 'uuid';

export interface AttachButtonProps extends ButtonProps {
  onFilesSelected: (files: AttachmentFile[]) => void;
}

export interface AttachmentFile extends File {
  isNew: boolean;
  newFileId: string;
}

export const AttachButton: React.FunctionComponent<AttachButtonProps> = ({ onFilesSelected, ...rest }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelected = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const fileData: AttachmentFile[] = Array.from(event.target.files || []) as AttachmentFile[];
    onFilesSelected(
      fileData.map(newFile => {
        newFile.isNew = true;
        newFile.newFileId = uuidv4();
        return newFile;
      })
    );
    (fileInputRef as React.MutableRefObject<HTMLInputElement>).current.value = '';
  };

  const handleAttachClick = () => {
    (fileInputRef as React.MutableRefObject<HTMLInputElement>).current.click();
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="*"
        multiple={true}
        onChange={handleFileSelected}
        style={{ display: 'none' }}
      />
      <Button {...rest} onClick={handleAttachClick} />
    </>
  );
};
